import { ColumnSelectionsModel } from "../../models";

export const CallCenterOngoingCallsColumns: ColumnSelectionsModel[] = [
    { name: 'Call Id', propertyName: 'CallId', isEnabled: false },
    { name: 'Call Sid', propertyName: 'CallSid', isEnabled: true },
    { name: 'Start Time', propertyName: 'CallStartedAt', isEnabled: true },
    { name: 'Call Status', propertyName: 'CallStatus', isEnabled: true },
    { name: 'Client Number', propertyName: 'ClientNumber', isEnabled: true },
    { name: 'Pin', propertyName: 'Pin', isEnabled: true },
    { name: 'Duration', propertyName: 'DurationMilliseconds', isEnabled: true },
    { name: 'Language', propertyName: 'LanguageName', isEnabled: true },

]